import styled from 'styled-components';

export const Wrapper = styled.div``;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20em;
  background-color: #fff;
`;
